import type { StackProps } from "@mui/material";
import { HStack } from "Components/_Shared/Core/Stack";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";

export const TimelinePill = ({ children, ...rest }: StackProps) => (
  <HStack
    alignItems="center"
    gap={Spacing.S}
    flexShrink={0}
    height={22}
    px={Spacing.M}
    borderRadius={Radius.MAX}
    fontSize={12}
    fontWeight={700}
    whiteSpace="nowrap"
    {...rest}
  >
    {children}
  </HStack>
);
